module.exports = __webpack_public_path__ + "static/media/old_home_logo.c469a1a1.png";